import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, ErreurApi } from '../api/client';
import { useAuth } from '../auth/contexte';
import { Champ } from '../composants/Champ';
import { BandeauAlerte } from '../composants/BandeauAlerte';

const LONGUEUR_MIN = 12;

export function MotDePasse() {
  const { rafraichir } = useAuth();
  const naviguer = useNavigate();
  const [ancien, setAncien] = useState('');
  const [nouveau, setNouveau] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [erreur, setErreur] = useState<string | null>(null);
  const [occupe, setOccupe] = useState(false);

  const discordance = confirmation.length > 0 && nouveau !== confirmation;
  const tropCourt = nouveau.length > 0 && nouveau.length < LONGUEUR_MIN;

  async function soumettre(evenement: FormEvent) {
    evenement.preventDefault();
    setErreur(null);
    setOccupe(true);
    try {
      await api.post<void>('/auth/mot-de-passe', { ancien, nouveau });
      // Le changement évince toutes les sessions : il faut se reconnecter.
      await rafraichir();
      naviguer('/connexion', { replace: true });
    } catch (e) {
      setErreur(e instanceof ErreurApi ? e.message : 'Changement impossible.');
    } finally {
      setOccupe(false);
    }
  }

  return (
    <div className="connexion">
      <div className="connexion__carte">
        <div className="connexion__marque">
          GSM<span>.</span>
        </div>
        <p className="connexion__sous">Changement de mot de passe</p>

        <BandeauAlerte nature="information" titre="Première connexion">
          Le mot de passe initial doit être remplacé. Toutes les sessions ouvertes seront fermées.
        </BandeauAlerte>

        {erreur && (
          <BandeauAlerte nature="refus" titre="Changement refusé">
            {erreur}
          </BandeauAlerte>
        )}

        <form onSubmit={(e) => void soumettre(e)} noValidate>
          <Champ
            label="Mot de passe actuel"
            type="password"
            value={ancien}
            onChange={(e) => setAncien(e.target.value)}
            autoComplete="current-password"
            required
          />
          <Champ
            label="Nouveau mot de passe"
            type="password"
            value={nouveau}
            onChange={(e) => setNouveau(e.target.value)}
            autoComplete="new-password"
            aide={`${LONGUEUR_MIN} caractères au minimum.`}
            erreur={tropCourt ? `Au moins ${LONGUEUR_MIN} caractères.` : undefined}
            required
          />
          <Champ
            label="Confirmation"
            type="password"
            value={confirmation}
            onChange={(e) => setConfirmation(e.target.value)}
            autoComplete="new-password"
            erreur={discordance ? 'Les deux saisies diffèrent.' : undefined}
            required
          />
          <button
            className="bouton bouton--pleine-largeur"
            type="submit"
            disabled={occupe || discordance || tropCourt || nouveau.length === 0}
          >
            {occupe ? 'Enregistrement…' : 'Changer le mot de passe'}
          </button>
        </form>
      </div>
    </div>
  );
}
